import React, { useEffect, useState } from "react";
import { getEarningsRelease } from "../data-tables/data/getData";
import DataTable from "examples/Tables/DataTable";
import { earningsReleaseData } from "../data-tables/data/dataTableData";
import { CircularProgress, Grid } from "@mui/material";
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";
import moment from "moment";

const EarningReleaseTable = ({ previewOnly }) => {
  const [inputData, setData] = useState(earningsReleaseData);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    handleEarningsRelease();
  }, []);

  const handleEarningsRelease = async () => {
    const earningsReleaseData = await getEarningsRelease();
    const formattedEarningsRelease = formatEarningsRelease(earningsReleaseData);
    setTimeout(() => {
      setData(formattedEarningsRelease);
      setLoading(false);
    }, 100);
  };

  const columns = [
    { Header: "Name", accessor: "name" },
    { Header: "Release Date", accessor: "releaseDate" },
    { Header: "Estimate", accessor: "estimate" },
  ];

  const formatEarningsRelease = (earningsReleaseData) => {
    let theTableData = earningsReleaseData.map((earnings, index) => {
      let name = `${earnings.name} (${earnings.symbol})`;
      let estimate = earnings.epsEstimate;
      if (!earnings.name) {
        name = `${earnings.symbol}`;
      }

      if (estimate == null) {
        estimate = "N.A.";
      }

      return {
        estimate: estimate,
        releaseDate: earnings.date,
        name: name,
      };
    });
    const earningsReleaseDataTable = {
      columns: columns.map((header) => {
        return { Header: header.Header, accessor: header.accessor };
      }),
      rows: theTableData,
    };

    return earningsReleaseDataTable;
  };

  if (isLoading)
    return <CircularProgress />

  return previewOnly ? (
    <Grid container spacing={2}>
      {inputData.rows.slice(0, 9).map((row, key) => {
        return (
          <Grid item xs={6} md={4}>
            <SoftTypography variant="body">
              <strong>{moment(row["releaseDate"]).format("D MMM YYYY")}</strong>
            </SoftTypography>
            <SoftBox>
              <SoftTypography variant="body2">{row["name"]}</SoftTypography>
            </SoftBox>
          </Grid>
        );
      })}
    </Grid>
  ) : (
    <div>
      <DataTable table={inputData} canSearch entriesPerPage={{ defaultValue: 25 }}></DataTable>
    </div>
  );
};

export default EarningReleaseTable;
